import { render, staticRenderFns } from "./TermsAndConditions.vue?vue&type=template&id=f65ec0b6&scoped=true"
import script from "./TermsAndConditions.vue?vue&type=script&lang=js"
export * from "./TermsAndConditions.vue?vue&type=script&lang=js"
import style0 from "./TermsAndConditions.vue?vue&type=style&index=0&id=f65ec0b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65ec0b6",
  null
  
)

export default component.exports